<template>
	<li class="header__nav__item threeD--wrap" ref="dropdown">
		<span
			class="header__nav__item__href drop"
			:class="{active: isOpen}"
			@click.stop="toggleOpen"
		>
			<slot name="link"></slot>
		</span>
		<ul
			class="header__dropdown threeD__animations"
			:class="{active: isOpen}"
			@click="toggleOpen"
		>
			<slot name="content"></slot>
		</ul>
	</li>
</template>


<script>

	export default {
		methods: {
			toggleOpen() {
				this.isOpen
					? this.$store.commit('updateHeaderDropdownEl', null)
					: this.$store.commit('updateHeaderDropdownEl', this.name)
			}
		},
		computed: {
			isOpen() {
				return this.$store.state.headerDropdownEl === this.name;
			}
		},
		props: ['name']
	}

</script>